module.exports = __webpack_public_path__ + "img/petlogo.ad86729f.png";